<template>
  <div
    class="sidenav-container"
    id="side_nav"
    :class="sideNav == true ? 'shownav' : 'hidenav'"
  >
    <div class="side-nav-bg-cover"></div>

    <div class="side-nav-section">
      <div class="side-nav">
        <div class="row">
          <div class="col">
            <i class="fa fa-times d-block d-sm-none" @click="closeNav()"></i>

            <div
              class="d-flex justify-content-center pt-4 bg-scope sidenav-shadow"
            >
              <div>
                <img
                  :src="entityDetails.legal_company_logo"
                  style="width: 150px"
                />
              </div>
              <!-- <div class="px-2">
                                <img src="@/assets/images/logo-2-sm.svg">
                            </div> -->
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="d-flex pb-3 justify-content-center bg-scope">
              <p class="text-vendor-id mt-4 text-center">
                <small>Account In-Use:</small><br />
                <b>{{ customer_id }}</b>

                <br /><br />
                <small>Mode of delivery:</small><br />
                <b>{{ deliveryModeLabel }}</b>

                <br /><br />

                <!-- <small>Available Balance:</small><br> -->
                <small>Available Balance:</small><br />
                <b class="amt_bal">&#x20A6;{{ thDFormat(availableBalance) }}</b>
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div
              class="entity-side d-sm-block d-lg-none d-md-none"
              style="color: black"
            >
              <EntityNav />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <ul>
              <li
                id="first_li"
                :class="page_active == 'dashboard' ? 'side-link-before' : ''"
              ></li>

              <li
                :class="
                  page_active == 'dashboard'
                    ? 'side-link active'
                    : page_active == 'wallet'
                    ? 'side-link-before'
                    : ''
                "
              >
                <a href="/dashboard" @click="closeNav()">
                  <svg
                    class=""
                    style="left: -20px; top: -1px"
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="#fff"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1406 4.22656C19.1406 3.99219 19.0391 3.78516 18.8828 3.63672L16.0195 0.28125C15.8672 0.105469 15.6484 0 15.4141 0H3.71875C3.48438 0 3.26562 0.101563 3.11328 0.28125L0.191406 3.71094C0.0664062 3.85937 0 4.04297 0 4.22656C0 4.22656 0 4.22656 0 4.23047V18.3398C0 18.7812 0.355469 19.1367 0.796875 19.1367H18.3359C18.7773 19.1367 19.1328 18.7812 19.1328 18.3398C19.1328 18.3398 19.1406 4.26172 19.1406 4.22656ZM17.5391 5.67187C17.5391 6.38672 16.957 6.96875 16.2422 6.96875H16.043C15.3281 6.96875 14.7461 6.38672 14.7461 5.67187V5.02344H17.5391V5.67187ZM13.1523 5.67187C13.1523 6.38672 12.5703 6.96875 11.8555 6.96875H11.6562C10.9414 6.96875 10.3594 6.38672 10.3594 5.67187V5.02344H13.1484V5.67187H13.1523ZM8.77344 5.67187C8.77344 6.38672 8.19141 6.96875 7.47656 6.96875H7.27734C6.5625 6.96875 5.98047 6.38672 5.98047 5.67187V5.02344H8.76953V5.67187H8.77344ZM4.39062 5.67187C4.39062 6.38672 3.80859 6.96875 3.09375 6.96875H2.89844C2.18359 6.96875 1.60156 6.38672 1.60156 5.67187V5.02344H4.39062V5.67187ZM4.09766 1.59766H15.0547L16.6172 3.42969H2.53516L4.09766 1.59766ZM8.42969 17.543V13.4141H10.7227V17.543H8.42969ZM12.3164 17.543V12.6172C12.3164 12.1758 11.9609 11.8203 11.5195 11.8203H7.63281C7.19141 11.8203 6.83594 12.1758 6.83594 12.6172V17.543H1.60156V8.25391C1.99219 8.44922 2.42969 8.5625 2.89844 8.5625H3.09766C3.92188 8.5625 4.66406 8.21484 5.19141 7.66406C5.71875 8.21875 6.46094 8.5625 7.28516 8.5625H7.48438C8.30859 8.5625 9.05078 8.21484 9.57812 7.66406C10.1055 8.21875 10.8477 8.5625 11.6719 8.5625H11.8711C12.6953 8.5625 13.4375 8.21484 13.9648 7.66406C14.4922 8.21875 15.2344 8.5625 16.0586 8.5625H16.2578C16.7227 8.5625 17.1641 8.44922 17.5547 8.25391V17.543H12.3164Z"
                      fill="#fff;"
                    />
                  </svg>
                  Home
                </a>
              </li>

              <li
                :class="
                  page_active == 'wallet'
                    ? 'side-link active'
                    : page_active == 'products'
                    ? 'side-link-before'
                    : page_active == 'dashboard'
                    ? 'side-link-after'
                    : ''
                "
              >
                <a href="/wallet" @click="closeNav()">
                  <svg
                    style="
                      left: -20px;
                      top: -1px;
                      enable-background: new 0 0 496.262 496.262;
                    "
                    width="18"
                    height="18"
                    fill="#fff"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 496.262 496.262"
                    xml:space="preserve"
                  >
                    <path
                      d="M477.832,274.28h-67.743v-65.106h67.743c10.179,0,18.43-8.243,18.43-18.424c0-10.182-8.251-18.43-18.43-18.43h-67.743  V81.982c0-13.187-2.606-22.866-7.743-28.762c-4.882-5.609-11.301-8.219-20.19-8.219c-8.482,0-14.659,2.592-19.447,8.166  c-5.077,5.902-7.654,15.599-7.654,28.821v90.343H227.627l-54.181-81.988c-4.637-7.317-8.997-14.171-13.231-20.75  c-3.812-5.925-7.53-10.749-11.042-14.351c-3.109-3.189-6.652-5.657-10.796-7.554c-3.91-1.785-8.881-2.681-14.762-2.681  c-7.501,0-14.31,2.055-20.83,6.277c-6.452,4.176-10.912,9.339-13.636,15.785c-2.391,6.126-3.656,15.513-3.656,27.63v77.626h-67.07   C8.246,172.326,0,180.574,0,190.755c0,10.181,8.246,18.424,18.424,18.424h67.07v65.113h-67.07C8.246,274.292,0,282.538,0,292.722  C0,302.9,8.246,311.14,18.424,311.14h67.07v103.143c0,12.797,2.689,22.378,8.015,28.466c5.065,5.805,11.487,8.5,20.208,8.5  c8.414,0,14.786-2.707,20.07-8.523c5.411-5.958,8.148-15.533,8.148-28.442V311.14h115.308l62.399,95.683  c4.339,6.325,8.819,12.709,13.287,18.969c4.031,5.621,8.429,10.574,13.069,14.711c4.179,3.742,8.659,6.484,13.316,8.157  c4.794,1.726,10.397,2.601,16.615,2.601c16.875,0,34.158-5.166,34.158-43.479V311.14h67.743c10.179,0,18.43-8.252,18.43-18.43 C496.262,282.532,488.011,274.28,477.832,274.28z M355.054,209.173v65.106h-60.041l-43.021-65.106H355.054z M141.936,134.364  l24.76,37.956h-24.76V134.364z M141.936,274.28v-65.106h48.802l42.466,65.106H141.936z M355.054,365.153l-35.683-54.013h35.683  V365.153z"
                    />
                  </svg>
                  Accounts
                </a>
              </li>

              <li
                :class="
                  page_active == 'products'
                    ? 'side-link active'
                    : page_active == 'orders'
                    ? 'side-link-before'
                    : page_active == 'wallet'
                    ? 'side-link-after'
                    : ''
                "
              >
                <a href="/products" @click="closeNav()">
                  <svg
                    style="left: -20px; top: -1px"
                    width="18"
                    height="18"
                    viewBox="0 0 20 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 12.4004H20V14.4004H0V12.4004ZM11.84 3.19039C11.94 2.95039 12 2.68039 12 2.40039C12 1.30039 11.1 0.400391 10 0.400391C8.9 0.400391 8 1.30039 8 2.40039C8 2.68039 8.06 2.95039 8.16 3.19039C4.25 4.00039 1.27 7.33039 1 11.4004H19C18.73 7.33039 15.75 4.00039 11.84 3.19039Z"
                      fill="white"
                    />
                  </svg>
                  Products
                </a>
              </li>

              <li
                :class="
                  page_active == 'orders'
                    ? 'side-link active'
                    : page_active == 'settings'
                    ? 'side-link-before'
                    : page_active == 'products'
                    ? 'side-link-after'
                    : ''
                "
              >
                <a href="/orders" @click="closeNav()">
                  <svg
                    style="left: -20px; top: -1px"
                    width="18"
                    height="18"
                    viewBox="0 0 19 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 0.599976V24.6H2.45572V23.7654C2.45572 23.3472 2.7959 23.0071 3.21403 23.0071C3.63215 23.0071 3.97234 23.3472 3.97234 23.7654V24.6H6.47957V23.7654C6.47957 23.3472 6.81973 23.0071 7.23783 23.0071C7.65593 23.0071 7.99611 23.3472 7.99611 23.7654V24.6H10.5034V23.7654C10.5034 23.3472 10.8435 23.0071 11.2616 23.0071C11.6797 23.0071 12.0199 23.3472 12.0199 23.7654V24.6H14.5272V23.7654C14.5272 23.3472 14.8673 23.0071 15.2854 23.0071C15.7036 23.0071 16.0437 23.3472 16.0437 23.7654V24.6H18.4995V0.599976H16.0438V1.43458C16.0438 1.85271 15.7036 2.19287 15.2855 2.19287C14.8674 2.19287 14.5272 1.85271 14.5272 1.43458V0.599976H12.0199V1.43458C12.0199 1.85271 11.6798 2.19287 11.2617 2.19287C10.8436 2.19287 10.5034 1.85271 10.5034 1.43458V0.599976H7.99614V1.43458C7.99614 1.85271 7.65595 2.19287 7.23785 2.19287C6.81976 2.19287 6.47957 1.85271 6.47957 1.43458V0.599976H3.97234V1.43458C3.97234 1.85271 3.63215 2.19287 3.21403 2.19287C2.7959 2.19287 2.45572 1.85271 2.45572 1.43458V0.599976H0ZM3.21403 3.86208C4.05028 3.86208 4.7892 3.43694 5.22597 2.79152C5.66273 3.43694 6.40161 3.86208 7.23788 3.86208C8.07418 3.86208 8.81308 3.43704 9.24982 2.79152C9.68656 3.43704 10.4254 3.86208 11.2617 3.86208C12.0981 3.86208 12.837 3.43702 13.2737 2.79152C13.7104 3.43704 14.4492 3.86208 15.2856 3.86208C15.8719 3.86208 16.4104 3.65312 16.8304 3.30577V21.8942C16.4104 21.5469 15.8719 21.3379 15.2856 21.3379C14.4493 21.3379 13.7104 21.7629 13.2737 22.4084C12.837 21.7629 12.0981 21.3379 11.2617 21.3379C10.4254 21.3379 9.68651 21.7629 9.24979 22.4084C8.81305 21.7629 8.07421 21.3379 7.23785 21.3379C6.40163 21.3379 5.66271 21.763 5.22594 22.4084C4.78917 21.763 4.05028 21.3379 3.214 21.3379C2.62765 21.3379 2.08918 21.5468 1.66919 21.8942V3.30577C2.08921 3.65312 2.62767 3.86208 3.21403 3.86208Z"
                      fill="white"
                    />
                    <path
                      d="M14.1817 5.86694H4.54181V7.53615H14.1817V5.86694Z"
                      fill="white"
                    />
                    <path
                      d="M14.1817 9.3335H4.54181V11.0027H14.1817V9.3335Z"
                      fill="white"
                    />
                    <path
                      d="M14.1817 12.8002H4.54181V14.4694H14.1817V12.8002Z"
                      fill="white"
                    />
                    <path
                      d="M14.1817 17.8079H8.0188V19.4771H14.1817V17.8079Z"
                      fill="white"
                    />
                  </svg>
                  Orders
                </a>
              </li>


              <li
                :class="
                  page_active == 'settings'
                    ? 'side-link active'
                    : page_active == 'complaints'
                    ? 'side-link-before'
                    : page_active == 'orders'
                    ? 'side-link-after'
                    : ''
                "
              >
                <a href="/settings" @click="closeNav()">
                  <svg
                    style="left: -20px; top: -1px"
                    width="18"
                    height="18"
                    viewBox="0 0 640 512"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
                    />
                  </svg>
                  Settings
                </a>
              </li>

              <li
                :class="
                  page_active == 'complaints'
                    ? 'side-link active'
                    : page_active == ''
                    ? 'side-link-before'
                    : page_active == 'settings'
                    ? 'side-link-after'
                    : ''
                "
              >
                <a href="/complaints" @click="closeNav()">
                  <svg
                    style="left: -20px; top: -1px"
                    width="18"
                    height="18"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 20L4 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM11 12H9V10H11V12ZM11 8H9V4H11V8Z"
                      fill="white"
                    />
                  </svg>
                  Support
                </a>
              </li>

              <li
                :class="page_active == 'complaints' ? 'side-link-after' : ''"
              ></li>

              <!-- <p class="bg-scope m-0" style="font-size: 14px; padding-left: 30px;  padding-top: 10px;">
                                <a href="/" class="text-white"  @click="closeNav()">
                                    <b><i class="fa fa-sign-out" style="padding-right:5px"></i> Logout</b>
                                </a>                                
                            </p> -->

              <li id="last_li"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EntityNav from "@/components/EntityNav.vue";
import axios from "axios";

export default {
  name: "SideNav",
  props: {
    page_active: String,
  },
  components: {
    EntityNav,
  },
  data() {
    return {
      customer_id: "",
      storeEntity: "",
      entityDetails: {},
      account: {},
      subprofiles: [],
      subacct_bal: 0,
      phone: "",
    };
  },

  mounted() {
    this.customer_id = this.$store.getters.sub_acct;

    if (!this.$store.getters.sub_acct_bal) {
      this.fetchAvailableBalance();
    }
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = "FMN - Select Mode of Delivery";
        this.storeEntity = this.$store.getters.entity;

        this.entityDetails = this.$store.getters.entityDetails.find(
          (entity) => entity.legal_company_code === this.storeEntity,
        );
      },
    },
  },
  computed: {
    sideNav() {
      return this.$store.getters.sideNav;
    },
    availableBalance() {
      return this.$store.getters.sub_acct_bal != undefined
        ? Number(this.$store.getters.sub_acct_bal)
        : 0;
    },
    deliveryModeLabel() {
      if (this.$store.getters.deliveryMode === "self") {
        return "Self Collection";
      }
      return this.storeEntity === "HFMP"
        ? "Honeywell-Delivery"
        : "FMN-Delivery";
    },
  },

  methods: {
    closeNav() {
      this.$store.commit("set_sideNav", false);
    },
    async fetchAvailableBalance() {
      try {
        axios({
          method: "get",
          url: this.$hostname + "/get-accounts-by-legal-entity",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.$store.getters.headerstoken}`,
          },
          params: { token: this.$store.getters.sub_acct }, // data = sub_acct
        }).then((res) => {
          this.subprofiles = res.data.data;

          const match = this.subprofiles.find(
            (x) => x.CustomerAccount === this.$store.getters.sub_acct,
          );

          if (match) {
            this.subacct_bal = match.CreditRemaining;
            this.phone = match.CustomerAccount;
            console.log("phone", this.phone);
            this.$store.commit("set_sub_acct_bal", this.subacct_bal);
          }
        });
      } catch (error) {
        console.error("Error fetching balance:", error);
        if (error.response.status === 401) {
          this.is401(error.response.status);
        }
      }
    },
  },

  beforeMount() {},
};
</script>

<style scoped>
.amt_bal {
  font-size: 16px;
  font-weight: 700;
}
.text-vendor-id small {
  font-size: 10px;
}
.shownav {
  display: block !important;
}
.fa-times {
  z-index: 10000;
  position: fixed;
  right: 28%;
  top: 10px;
  color: #efd857;
  font-size: 20px;
}
</style>
